import { styled } from '@mui/material';
import React from 'react';

const Iframe = styled('iframe')(({ theme }) => ({
  width: theme.breakpoints.values.md,
  minHeight: '100%',
  height: '100%',
  margin: '0 auto',
}));

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  minHeight: '100vh',
  padding: theme.spacing(6, 0),
  borderRadius: theme.shape.borderRadius,
}));

type PortalProps = Omit<React.HTMLProps<HTMLIFrameElement>, 'as'> & {
  url: string;
  title: string;
};

const PDFViewer = ({ url, title }: PortalProps) => (
  <Container>
    <Iframe src={url} title={title} allowFullScreen />
  </Container>
);

export default PDFViewer;
